/**
 * seamlessPortalsFlag — the one place that decides whether a portal keeps the
 * page (plan 25, D36). Default OFF until DJ has playtested it.
 *
 *   ?seamlessPortals=1 / =0   on the boot URL wins (carried across portals)
 *   localStorage['h2k.seamlessPortals'] = '1'   per-browser opt-in, so a
 *                              helix2000.com `/play` session can turn it on
 *                              from the console without a long URL
 *   helix2000.com: the boot stores `?seamlessPortals=1` into that key before
 *                  D44 drops the parameter (captureSeamlessPortalsParam)
 */
import { bootParam } from '../../../config/boot/bootUrl';

export const SEAMLESS_PORTALS_PARAM = 'seamlessPortals';
export const SEAMLESS_PORTALS_STORAGE_KEY = 'h2k.seamlessPortals';

export function isSeamlessPortalsEnabled(): boolean {
  const param = bootParam(SEAMLESS_PORTALS_PARAM);
  if (param === '1' || param === 'true') return true;
  if (param === '0' || param === 'false') return false;
  try {
    return globalThis.localStorage?.getItem(SEAMLESS_PORTALS_STORAGE_KEY) === '1';
  } catch {
    return false; // storage blocked
  }
}

/**
 * D44 (2026-10-09): helix2000.com drops every query parameter a page was not
 * sent with by the game, so `?seamlessPortals=1` cannot ride the URL there.
 * The main-game boot (applyMainGameRedirect.ts) calls this first: `=1`/`true`
 * stores the flag for this browser, `=0`/`false` clears it. Elsewhere the
 * parameter keeps working per URL, as before.
 */
export function captureSeamlessPortalsParam(
  params: URLSearchParams,
  storage?: Pick<Storage, 'setItem' | 'removeItem'>,
): void {
  const param = params.get(SEAMLESS_PORTALS_PARAM);
  try {
    const store = storage ?? globalThis.localStorage;
    if (param === '1' || param === 'true') store?.setItem(SEAMLESS_PORTALS_STORAGE_KEY, '1');
    else if (param === '0' || param === 'false') store?.removeItem(SEAMLESS_PORTALS_STORAGE_KEY);
  } catch {
    // Storage blocked: the flag stays as it was.
  }
}
